module.exports = __webpack_public_path__ + "img/facebook-icon.61a96c78.png";